module.exports = __webpack_public_path__ + "bdeee65eb960ae28d4c94ad887d34a8c.png";